import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { LeadListComponent } from './components/lead-list/lead-list.component';
import { LeadListBusinessService } from './resources/lead-list-business.service';

const routes: Routes = [createRoute({
  component: LeadListComponent,
  path: '',
  init: LeadListBusinessService,
  auth: {
    permission: 'Sales.Leads.LIST',
  },
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderLeadsRoutingModule {
}
